<template>
    <div class="product-part">
        <div class="is-clearfix">
            <router-link :to="{ name: 'product', params: {id: part.product.id}}">
                {{ part.product.name }}
            </router-link>
            <span v-if="!editing">
                x {{ part.count }} {{ part.title ? '-' : '' }} {{ part.title }}
            </span>
            <div class="is-pulled-right">
                <button v-if="editing" type="button" class="button is-primary">Save</button>
                <button type="button" class="button" @click="editing = !editing">{{ editing ? 'Cancel' : 'Edit' }}</button>
            </div>
        </div>
        <div v-if="editing">
            <br/>
            <div class="field product-field">
                <div class="columns">
                    <form-control type="number"
                                  :value="part.count"
                                  placeholder="Count"
                                  class="column is-6"
                    ></form-control>
                    <form-control type="text"
                                  :value="part.title"
                                  placeholder="title"
                                  class="column is-6"
                    ></form-control>
                </div>
            </div>
            <div class="product-field">
                <form-control type="textarea"
                              :value="part.description"
                              placeholder="Description"
                ></form-control>
            </div>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss">
    .product-part {
        margin-bottom: 1rem;
    }
</style>

<script>
    export default {
        props: ['part'],
        data() {
            return {
                editing: false
            }
        },
    };
</script>



// WEBPACK FOOTER //
// ProductPart.vue?db04f6c4